module.exports = __webpack_public_path__ + "static/media/logo-login.005f94bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-login.png
// module id = 48
// module chunks = 0